export default "__VITE_ASSET__FJ72GBvi__"